import {useNavigate} from "react-router-dom";
import {AuthService} from "./services/AuthService";
import {useState} from "react";
import Swal from "sweetalert2";
import SimpleLoadingComponent from "../components/simple/simple-loading-component";
import {NewLoading} from "./components/NewLoading";

const NewRegister = () => {
    const navigate = useNavigate();

    const [registerLoading, setRegisterLoading] = useState(false);

    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        whatsapp: "",
        password: "",
        confirmPassword: "",
        termsAccepted: false
    });

    const handleChange = (e) => {
        const {id, value, type, checked} = e.target;
        setFormData(prev => ({
            ...prev,
            [id]: type === "checkbox" ? checked : value
        }));
    };

    const onRegisterBtnClick = async () => {

        setRegisterLoading(true);
        try {
            const response = await AuthService().register(
                formData.fullName,
                formData.email,
                formData.whatsapp,
                formData.password,
                formData.confirmPassword
            );

            await Swal.fire({
                title: "",
                text: "Cadastro efetuado com sucesso!",
                icon: "success"
            });

            navigate('/');
        } catch (e) {
            Swal.fire({
                title: "",
                text: e.response.data.message,
                icon: "warning"
            });
        }
        setRegisterLoading(false);
    };

    return (<div className={"register-page"}>
        <div className="flex flex-col items-center justify-center min-h-screen p-4 md:p-8">
            {/* Main Container */}
            <div className="w-full max-w-md">
                {/* Header */}
                <div className="w-full flex justify-between items-center mb-8">
                    <div className="flex items-center">
                        <div
                            className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center mr-4 shadow-md">
                            <i className="fas fa-user-plus text-white text-xl"></i>
                        </div>
                        <div>
                            <h1 className="text-2xl font-bold text-gray-200">DDtank <span
                                className="text-blue-200">Splush</span></h1>
                            <p className="text-sm text-white">Junte-se à nossa comunidade</p>
                        </div>
                    </div>

                    <button onClick={() => navigate('/')}
                            className="back-button flex items-center text-white transition-colors">
                        <i className="fas fa-arrow-left mr-2"></i>
                        <span className="hidden sm:inline">Voltar</span>
                    </button>
                </div>

                {/* Register Container */}
                <div className="register-container bg-white w-full mb-8">
                    {/* Register Header */}
                    <div className="register-header text-white text-center relative">
                        <div className="relative z-10">
                            <h1 className="text-2xl md:text-3xl font-bold mb-2">Crie sua conta</h1>
                            <p className="text-sm md:text-base opacity-90">Comece sua aventura no DDtank hoje
                                mesmo</p>
                        </div>
                    </div>

                    {/* Register Form */}
                    <div className="register-form p-6 md:p-8">
                        <form id="registrationForm">
                            {/* Nome Completo */}
                            <div className="input-register-group">
                                <i className="fas fa-user"></i>
                                <input type="text" id="fullName" placeholder="Nome completo" value={formData.fullName}
                                       onChange={handleChange}

                                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"/>
                                {/*<div id="fullNameError" className="error-message">Por favor, insira seu nome*/}
                                {/*    completo*/}
                                {/*</div>*/}
                            </div>

                            {/* Email */}
                            <div className="input-register-group">
                                <i className="fas fa-envelope"></i>
                                <input type="email" id="email" placeholder="E-mail" value={formData.email}
                                       onChange={handleChange}
                                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"/>
                                {/*<div id="emailError" className="error-message">Por favor, insira um e-mail válido*/}
                                {/*</div>*/}
                            </div>

                            {/* WhatsApp */}
                            <div className="input-register-group">
                                <i className="fas fa-phone"></i>
                                <input type="tel" id="whatsapp" placeholder="WhatsApp (com DDD)"
                                       value={formData.whatsapp}
                                       onChange={handleChange}
                                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"/>
                                {/*<span className="text-xs text-gray-500 absolute -bottom-5 left-0">Ex: (11) 98765-4321</span>*/}
                                {/*<div id="whatsappError" className="error-message">Por favor, insira um número*/}
                                {/*    válido*/}
                                {/*</div>*/}
                            </div>

                            {/* Senha */}
                            <div className="input-register-group">
                                <i className="fas fa-lock"></i>
                                <input type="password" id="password" placeholder="Senha" value={formData.password}
                                       onChange={handleChange}
                                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"/>
                                {/*<span className="text-xs text-gray-500 absolute -bottom-5 left-0">Mínimo 8 caracteres</span>*/}
                                {/*<div id="passwordError" className="error-message">A senha deve ter no mínimo 8*/}
                                {/*    caracteres*/}
                                {/*</div>*/}
                            </div>

                            {/* Confirmar Senha */}
                            <div className="input-register-group mb-6">
                                <i className="fas fa-lock"></i>
                                <input type="password" id="confirmPassword" placeholder="Confirmar senha"
                                       value={formData.confirmPassword}
                                       onChange={handleChange}
                                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"/>
                                {/*<div id="confirmPasswordError" className="error-message">As senhas não coincidem*/}
                                {/*</div>*/}
                            </div>

                            {/* Termos de Uso */}
                            <div className="mb-6">
                                <label className="terms-register-checkbox">
                                    <input type="checkbox" id="terms"/>
                                    <span className="checkmark-register"></span>
                                    <span className="text-sm ml-2 text-gray-700">Eu concordo com os <a href="/legal"
                                                                                                       className="text-blue-500 hover:underline">Termos de Uso</a> e <a
                                        href="/legal"
                                        className="text-blue-500 hover:underline">Política de Privacidade</a> do DDtank Splush</span>
                                </label>
                                {/*<div id="termsError" className="error-message mt-2">Você deve aceitar os termos*/}
                                {/*</div>*/}
                            </div>

                            {/* Botão de Cadastro */}
                            {
                                !registerLoading ? (
                                    <button type="button" onClick={onRegisterBtnClick}
                                            className="btn-register w-full py-3 px-4 text-white font-medium rounded-lg mb-4 shadow-md">
                                        <span className="relative z-10">Criar conta</span>
                                    </button>
                                ) : (
                                    <div className={"flex justify-center items-center"}>
                                        <NewLoading size={125}></NewLoading>
                                    </div>
                                )
                            }

                            <div className="divider-register"></div>

                            {/* Login com Redes Sociais */}
                            {/*<p className="text-center text-gray-600 mb-4">Ou cadastre-se com</p>*/}

                            {/*<div className="flex justify-center space-x-4 mb-6">*/}
                            {/*    <button type="button"*/}
                            {/*            className="social-register-btn bg-blue-600 text-white hover:bg-blue-700">*/}
                            {/*        <i className="fab fa-facebook-f"></i>*/}
                            {/*    </button>*/}
                            {/*    <button type="button"*/}
                            {/*            className="social-register-btn bg-red-500 text-white hover:bg-red-600">*/}
                            {/*        <i className="fab fa-google"></i>*/}
                            {/*    </button>*/}
                            {/*    <button type="button"*/}
                            {/*            className="social-register-btn bg-black text-white hover:bg-gray-800">*/}
                            {/*        <i className="fab fa-apple"></i>*/}
                            {/*    </button>*/}
                            {/*</div>*/}

                            <p className="text-center text-sm text-gray-600">
                                Já tem uma conta? <button onClick={() => navigate('/')}
                                                          className="text-blue-500 hover:underline font-medium">Faça
                                login</button>
                            </p>
                        </form>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <div className="w-full max-w-md bg-gray-100 rounded-lg p-4 text-center text-xs text-gray-600 mt-8">
                <p>DDtank Splush © 2025 Todos os direitos reservados</p>
                <div className="mt-2 flex justify-center space-x-4">
                    <a href="/legal" className="text-blue-500 hover:underline">Termos</a>
                    <a href="/legal" className="text-blue-500 hover:underline">Privacidade</a>
                    <a href="/legal" className="text-blue-500 hover:underline">Suporte</a>
                </div>
            </div>
        </div>
    </div>);
}

export default NewRegister;